import { RootState } from '../index';

export const selectEpepState = (state: RootState) => state.epep;
